import React from 'react';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableRow,
  Checkbox,
  IconButton,
  Dialog,
  DialogContent,
  Tooltip,
  AppBar,
  Toolbar,
  Typography
} from '@material-ui/core';
import { apiRequest, apiPost } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import SaveIcon from '@material-ui/icons/Save';

import './configuration.less';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
// import { GetSectionPermission } from "../../utils/helper";
import { Responsive, WidthProvider } from 'react-grid-layout';
// import RenderLayout from "../Dashboard/RenderLayout";
import camelcaseKeys from 'camelcase-keys';
import RenderLayout from '../Dashboard/RenderLayout';
import { GetSectionPermission, IsSectionVisible } from '../../utils/helper';
import { SECTIONS } from "../../constants/appConstants";
const ResponsiveGridLayout = WidthProvider(Responsive);
const WidgetContainer = 'WC';

export default class GroupWidgetMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessGroups: [],
      selectedGroup: this.props.group,
      widgetConfig: [],
      openCustomizedLayout: false,
      layout: [],
      layoutUpdated: false
    };
  }

  componentDidMount() {
    this.GetAccessGroups();
    this.GetWidgetMasterList();
  }

  onLayoutChange = (layout, layouts) => {
    // localStorage.setItem("layout", JSON.stringify(layout));
    // console.log(layout, layouts);
    this.setState({ layout: layout, layoutUpdated: !this.state.layoutUpdated });
  };

  GetLayout = (widgetconfig) => {
    const layouts = [];

    const newLayout = [];

    widgetconfig.forEach((config) => {
      const key = WidgetContainer + '_' + config.widgetId + '_' + config.widgetId;
      let layout = layouts.find((x) => x.i === key);
      if (layout === undefined) {
        layout = {};
      }
      layout.w = config.minWidth;
      layout.h = config.minHeight;
      layout.x = config.xPosition;
      layout.y = config.yPosition;
      layout.i = key;
      newLayout.push(layout);
    });
    newLayout.sort((a, b) => a.x - b.x);
    newLayout.sort((a, b) => a.y - b.y);
    return newLayout;
  };

  GetWidgetMasterList = () => {
    const { selectedGroup } = this.state;

    apiRequest({
      url:
        API_URL.Dashboard.GetWidgetMasterListByGroup + '?groupId=' + selectedGroup
    }).then(({ data: response }) => {
      const layout = this.GetLayout(camelcaseKeys([...response]));
      this.setState({
        widgetConfig: response || [],
        layout: layout
      });
    });
  };

  GetAccessGroups = () => {
    apiRequest({
      url: API_URL.Users.GetAccessGroups
    }).then(({ data: response }) => {
      this.setState({
        accessGroups: response || []
        // configuration: configuration
      });
    });
  };

  handelChange = (value, key, index) => {
    const { widgetConfig } = this.state;
    if (key === 'addToDashboard') {
      widgetConfig[index][key] = value;
    } else {
      if (value === false) {
        widgetConfig[index].addToDashboard = value;
      }
      widgetConfig[index][key] = value;
    }
    this.setState({ widgetConfig: widgetConfig });
  };

  SaveGroupWidgetMapping = () => {
    const { widgetConfig, selectedGroup, layout } = this.state;
    if (selectedGroup === 0 || selectedGroup === undefined) {
      ShowToast(
        'Please select user group',
        toastType.ERROR,
        5000,
        commonLabels.somethingWrong.code
      );
      return;
    }
    widgetConfig.forEach(function (config, i) {
      const key = WidgetContainer + '_' + config.widgetId + '_' + config.widgetId;
      const obj = layout.find((x) => x.i === key);
      if (obj !== undefined) {
        config.minWidth = obj.w;
        config.minHeight = obj.h;
        config.xPosition = obj.x;
        config.yPosition = obj.y;
      }
      config.accessGroupId = selectedGroup.toString();
    });

    apiPost({
      url: API_URL.Dashboard.UpdateGroupWidgetMapping,
      params: {},
      postBody: widgetConfig
    }).then(({ success: isExecuted }) => {
      if (isExecuted === true) {
        ShowToast(
          'Saved Successfully.',
          toastType.SUCCESS,
          5000,
          200
        );
      } else {
        ShowToast(
          'Error Occurred! Unable to save.',
          toastType.ERROR,
          5000,
          500
        );
      }
      this.GetWidgetMasterList();
    });

    // apiPost({
    //   url: API_URL.Dashboard.UpdateGroupWidgetMapping,
    //   params: {},
    //   postBody: widgetConfig
    // }).then(({ data: response }) => {
    //   if (response.success) {
    //     ShowToast(
    //       commonLabels.widgetConfigurationUpdateSuccess.message,
    //       toastType.SUCCESS,
    //       5000,
    //       commonLabels.widgetConfigurationUpdateSuccess.code
    //     );
    //   } else {
    //     ShowToast(
    //       commonLabels.somethingWrong.message,
    //       toastType.ERROR,
    //       5000,
    //       commonLabels.somethingWrong.code
    //     );
    //   }
    //   this.GetWidgetMasterList();
    // });
  };

  render() {
    const {
      accessGroups,
      widgetConfig,
      selectedGroup,
      openCustomizedLayout,
      layout,
      layoutUpdated
    } = this.state;

    // const permission = GetSectionPermission(
    // //   SECTIONS.CONFIGURATION,
    // //   SECTIONS.CONFIGURE_GROUP_WIDGET
    // );
    // const IsEditable = permission.accessTypeId > 1 ? true : false;
    // const ShowData = permission.showData;

    return (
      <>
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell key={'configureHeader'} className="content-header">
                {' '}
                <div className="content-header">
                  Configure Group Widget Access Permissions
                </div>{' '}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell key={'configurableCell'}>
                <div className="col-xs-12">
                  <FormControl style={{ width: '100%' }}>
                    <InputLabel size="small" id={'WidgetTypelabel'}>
                      User Group
                    </InputLabel>
                    <Select
                      required
                      style={{ width: '100%' }}
                      labelId={'WidgetTypelabel'}
                      id={'WidgetTypelabelSelect'}
                      value={selectedGroup}
                      defaultValue={selectedGroup}
                      onChange={(event) => {
                        this.setState(
                          { selectedGroup: event.target.value },
                          () => this.GetWidgetMasterList()
                        );
                      }}
                      placeholder={'Select User Group'}
                    >
                      {accessGroups.map((group, index) => (
                        <MenuItem
                          key={'MenuUG' + index}
                          size="medium"
                          value={group.accessGroupId.toString()}
                        >
                          {/* {group.description} */}
                          {group.accessGroupName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>{' '}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header sub-section row co-xs-12"
              >
                <div className="content-header row col-xs-12">
                  Widget Permission
                  <div className="end-xs col-xs">
                    {/* {this.state.IsEditable && ( */}
                    {IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_GROUP_WIDGET, SECTIONS.ADD_EDIT) &&
                      (<>
                        <Tooltip title="Update Layout">
                          <IconButton
                            className="white-button"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              this.setState({ openCustomizedLayout: true });
                            }}
                          >
                            <DashboardOutlinedIcon fontSize="small"></DashboardOutlinedIcon>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Save">
                          <IconButton
                            className="white-button"
                            color="inherit"
                            size="small"
                            onClick={this.SaveGroupWidgetMapping}
                          >
                            <SaveIcon fontSize="small"></SaveIcon>
                          </IconButton>
                        </Tooltip>{' '}
                      </>)
                    }
                    {/* )} */}
                  </div>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell key={'configureHeadercell2'}>
                <div className="col-xs-12">
                  <TableContainer>
                    <Table
                      aria-labelledby="tableTitle"
                      size={'small'}
                      aria-label="enhanced table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell key={'WidgetName'}>
                            {' '}
                            Widget Name{' '}
                          </TableCell>
                          <TableCell key={'WidgetType'}> Type </TableCell>
                          <TableCell key={'WidgetAccessible'}>
                            {' '}
                            Is Accessible{' '}
                          </TableCell>
                          <TableCell key={'WidgetDefault'}>
                            {' '}
                            Add to Dashboard{' '}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {widgetConfig.map((row, index) => {
                          return (
                            <TableRow key={row.name}>
                              <TableCell key={'WidgetName' + index}>
                                {' '}
                                {row.name}{' '}
                              </TableCell>
                              <TableCell key={'WidgetType' + index}>
                                {' '}
                                {row.widgetTypeName}{' '}
                              </TableCell>
                              <TableCell key={'WidgetAccessible' + index}>
                                <Checkbox
                                  // disabled={!this.state.IsEditable}
                                  disabled={!IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_GROUP_WIDGET, SECTIONS.ADD_EDIT)}
                                  id={'IsAccessible' + index}
                                  color="primary"
                                  defaultValue={row.isAccessible}
                                  checked={row.isAccessible}
                                  onChange={(event) => {
                                    this.handelChange(
                                      event.target.checked,
                                      'isAccessible',
                                      index
                                    );
                                  }}
                                />{' '}
                              </TableCell>
                              <TableCell key={'WidgetDefault' + index}>
                                <Checkbox
                                  // disabled={
                                  //   this.state.IsEditable && row.isAccessible
                                  //     ? false
                                  //     : true
                                  // }
                                  disabled={!IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_GROUP_WIDGET, SECTIONS.ADD_EDIT)}
                                  id={'AddToDashboard' + index}
                                  color="primary"
                                  defaultValue={row.addToDashboard}
                                  checked={row.addToDashboard}
                                  onChange={(event) => {
                                    this.handelChange(
                                      event.target.checked,
                                      'addToDashboard',
                                      index
                                    );
                                  }}
                                />{' '}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Dialog
          fullScreen
          open={openCustomizedLayout}
          onClose={() => {
            this.setState({ openCustomizedLayout: false });
          }}
          title={'Layout settings'}
        >
          <AppBar style={{ position: 'relative', backgroundColor: '#002f6c' }}>
            <Toolbar>
              <Typography
                variant="h6"
                className="app-header-white"
                style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
              >
                {'Layout settings'}
              </Typography>
              {/* {IsEditable && ( */}
              <>
                <Tooltip title="Save">
                  <IconButton
                    className="white-button"
                    color="inherit"
                    size="small"
                    onClick={this.SaveGroupWidgetMapping}
                  >
                    <SaveIcon fontSize="small"></SaveIcon>
                  </IconButton>
                </Tooltip>{' '}
              </>
              {/* )} */}
              <Tooltip title="Close">
                <IconButton
                  className="white-button"
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({ openCustomizedLayout: false });
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {widgetConfig && (
              <>
                <ResponsiveGridLayout
                  className="layout"
                  layouts={{ lg: layout }}
                  onLayoutChange={this.onLayoutChange}
                  breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                  cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                  rowHeight={30}
                  preventCollision={false}
                  autoSize={true}
                  useCSSTransforms={true}
                  onDragStop={this.ItemCallback}
                  onResizeStop={this.ItemCallback}
                // compactType="horizontal"
                >
                  {widgetConfig &&
                    (
                      widgetConfig.filter((x) => x.addToDashboard === true) || []
                    ).map((config, index) => {
                      config.title = config.name;
                      const layoutConfig = layout.find(
                        (x) =>
                          x.i ===
                          WidgetContainer +
                          '_' +
                          config.widgetId +
                          '_' +
                          config.widgetId
                      );
                      (layoutConfig || {}).isDraggable = true;
                      return (
                        <div
                          id={
                            WidgetContainer +
                            '_' +
                            config.widgetId +
                            '_' +
                            config.widgetId
                          }
                          key={
                            WidgetContainer +
                            '_' +
                            config.widgetId +
                            '_' +
                            config.widgetId
                          }
                          data-grid={layoutConfig}
                          widgetId={config.widgetId}
                        >
                          <RenderLayout
                            datacenterList={[]}
                            propertyId={9}
                            key={'widget' + config.widgetId + config.widgetId}
                            startDate={moment()
                              .subtract(6, 'month')
                              .format('MM/DD/yyyy')}
                            endDate={moment().format('MM/DD/yyyy')}
                            widgetconfig={camelcaseKeys({ ...config })}
                            OpenWidgetConfigurationPanel={
                              this.OpenWidgetConfigurationPanel
                            }
                            onRemoveWidgetMapping={this.RemoveWidgetMapping}
                            layoutUpdated={layoutUpdated}
                          ></RenderLayout>
                        </div>
                      );
                    })}
                  {/* {<div key="AddWidget" data-grid={{ x: Math.max.apply(Math, layout.map(function (o) { return o.x; })), y: Math.max.apply(Math, layout.map(function (o) { return o.y; })), w: 1, h: 3, isResizable: false }}> <div className="addWidget">
                                <button onClick={this.OpenWidgetPanel}>  <p>
                                    <SettingsApplicationsOutlined style={{ color: grey[500] }} ></SettingsApplicationsOutlined></p> <span style={{ color: grey[500] }}>Add widgets</span></button>  </div> </div>} */}
                </ResponsiveGridLayout>
              </>
            )}
          </DialogContent>
        </Dialog>
        {/* <Dialog open={openCustomizedLayout} close={()=>{this.setState({openCustomizedLayout:false})}} className="white-button" title={"Layout Settings"}>
            <div>Test</div>
          </Dialog> */}
      </>
    );
  }
}
